import React from 'react';
import classStyle from './Doc.module.scss';
import router from '@src/routes/router';
import Highlighter from 'react-highlight-words';
import { docTypes } from './docData';

export default function Doc() {
    const { type = 'Verified' } = router.getQuery();
    const selectType = docTypes.find((v) => v.key === type) ?? docTypes[0];

    return (
        <div className={classStyle.page}>
            <div className={classStyle.pageTitle}>{selectType.title}</div>
            {selectType.text && <div className={classStyle.pageText}>{selectType.text}</div>}
            <div className={classStyle.pageContent}>
                {selectType.list.map((v, i) => {
                    const {
                        title,
                        subTitle,
                        titleHiglights = [],
                        text,
                        textHiglights = [],
                        imgs = [],
                    } = v;

                    return (
                        <div key={i} className={classStyle.contentItem}>
                            {title && (
                                <div className={classStyle.contentItemTitleBar}>
                                    <div className={classStyle.contentItemTitle}>
                                        <Highlighter
                                            highlightStyle={{
                                                color: '#B7292A',
                                                backgroundColor: 'transparent',
                                            }}
                                            searchWords={titleHiglights}
                                            autoEscape={true}
                                            textToHighlight={title}
                                        />
                                    </div>
                                    {subTitle && (
                                        <div className={classStyle.contentItemSubTitle}>
                                            {subTitle}
                                        </div>
                                    )}
                                </div>
                            )}
                            {text && (
                                <div className={classStyle.contentItemText}>
                                    <Highlighter
                                        highlightStyle={{
                                            color: '#B7292A',
                                            backgroundColor: 'transparent',
                                        }}
                                        searchWords={textHiglights}
                                        autoEscape={true}
                                        textToHighlight={text}
                                    />
                                </div>
                            )}
                            <div className={classStyle.contentItemImgs}>
                                {imgs.map((v, j) => (
                                    <img
                                        key={j}
                                        src={v.img}
                                        className={v.className ?? classStyle.contentImg}
                                        alt=""
                                    />
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
